import { ResultOf } from 'gql.tada';
import { graphql } from '../../../graphql/graphql';

export const propertyPageCtaButtonFragment = graphql(`
  fragment PropertyPage_CtaButton on PropertyPage_CtaButton {
    __typename
    ctaVariant
    text
    buttonVariant
    ariaLabel
    iconName
    iconPlacement
    sizeVariant
    buttonType
    trackingEvent
  }
`);

export type PropertyPageCtaButton = ResultOf<typeof propertyPageCtaButtonFragment>;
